import React from "react";
import "./elevenandtwelth.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../footer/Footer";
import mainImg from "../../Assets/faq/mainimg.png";
import dot from "../../Assets/faq/dot.png";
import clarity from "../../Assets/faq/clarity.png";
import practice from "../../Assets/faq/Practice.png";
import Revise from "../../Assets/faq/Revise well.png";
import selfStudy from "../../Assets/faq/Self-study.png";
import regular from "../../Assets/faq/regular.png";
import testPaper from "../../Assets/faq/test papers.png";
import sleep from "../../Assets/faq/sleep.png";
import eat from "../../Assets/faq/eat.png";
import calm from "../../Assets/faq/calm.png";

import person from "../../Assets/testimonial/person.png";
import coma from "../../Assets/testimonial/coma.png";

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { Helmet } from "react-helmet";
import Newnavbar from "../newNavbar/Newnavbar";
import LogoContact from "../logoContact/logoContact";
import { FaWhatsapp } from "react-icons/fa";
import Newenqire from "../Enquire Form/Newenqire";

import Breadcrumbs from '../../seo/Breadcrumbs';
export default function ElevenAndTwelth() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Thane's Top Coaching for 11th & 12th Science Classes</title>
        <meta
          name="title"
          content="11th & 12th Science Coaching Classes in Thane"
        />
        <meta
          name="description"
          content="Secure your future with top 11th & 12th Science coaching in Thane. Get clear concept delivery, doubt solving, and structured preparation for board exams and entrance tests."
        />
        <link
          rel="canonical"
          href="https://nayakstutorials.com/11th-12th-science-coaching-classes-in-thane"
        />

        {/**/}
      </Helmet>
      {/* <Navbar /> */}

      <div className="wpfloat">
        <LogoContact />
        <Newnavbar />
            <Breadcrumbs route="/11th-12th-science-coaching-classes-in-thane" />

        <div className="elevenTopDiv">

          <div className="elevenMain">
            <div className="elevenLeftDiv">
              <img src={mainImg} />
            </div>
            <div className="elevenRightDiv">
              <h1>
                Nayak’s Tutorials – Best 11
                <sup style={{ textTransform: "lowercase" }}>th</sup>-12
                <sup style={{ textTransform: "lowercase" }}>th</sup> Science
                Coaching in Thane
              </h1>
              <p>
                At Nayak’s Tutorials, Thane, we provide offline coaching for
                Class 11th & 12th Science, helping students build a strong
                foundation in Physics, Chemistry, Biology, and Mathematics. We
                also offer specialized coaching for IIT-JEE & NEET, ensuring
                students achieve outstanding results in board exams and
                competitive entrance tests. <br></br> For{" "}
                <b>Science students</b>, a strong foundation in{" "}
                <b>Physics, Chemistry, Mathematics, and Biology</b> is{" "}
                <b>crucial</b> for excelling in{" "}
                <b>
                  board exams and competitive entrance tests like IIT-JEE & NEET
                </b>
                . The concepts introduced in <b>Class 11th and 12th</b> serve as
                the <b>backbone for advanced studies</b> in engineering,
                medicine, and research fields. Unlike rote learning,{" "}
                <b>
                  science demands conceptual clarity, analytical thinking, and
                  problem-solving skills
                </b>{" "}
                to tackle complex topics effectively. A weak foundation can make
                higher studies challenging, whereas a structured approach with{" "}
                <b>
                  expert guidance, regular practice, and doubt-solving sessions
                </b>{" "}
                can help students master their subjects and achieve their career
                goals. At <b>Nayak’s Tutorials, Thane</b>, we ensure that{" "}
                <b>
                  every student builds confidence in science through interactive
                  learning, separate JEE & NEET batches, and a well-structured
                  curriculum
                </b>
                , setting them up for academic and professional success.{" "}
              </p>
            </div>
          </div>
          <div className="ElevenSeconDiv">
            <h3>
              <b>
                Offline Coaching in Thane | IIT-JEE & NEET Special Batches |
                Small Class Sizes | Personalized Learning 
              </b>
            </h3>
            <p>
              Class 11th is the foundation of advanced science studies, and a
              strong understanding of core subjects is crucial for board exams
              and competitive exams like IIT-JEE & NEET. At Nayak’s Tutorials,
              Thane, we offer:
            </p>

            <p>
              ✔️ Concept-Based Learning: Real-world applications, case studies &
              practical problem-solving<br></br>
              ✔️ Separate Batches for IIT-JEE & NEET: Specialized coaching with
              customized strategies<br></br>
              ✔️ Regular Assessments: Weekly tests, topic-wise revisions &
              prelims for improved performance<br></br>
              ✔️ Expert Faculty for JEE & NEET: Industry-experienced mentors
              ensuring top results<br></br>
              ✔️ Personalized Attention: Small batch sizes, interactive
              doubt-solving & one-on-one mentorship<br></br>
              <a href="https://nayakstutorials.com/ace-40-batch-for-neet-ug-integrated">
                🔗 Explore NEET Coaching in Thane
              </a>{" "}
              |{" "}
              <a href="https://nayakstutorials.com/ace-40-batch-for-iit-jee-integrated">
                🔗 Explore IIT-JEE Coaching in Thane
              </a>
            </p>
          </div>

          <div className="ElevenSeconDiv">
            <h2>Science Coaching Programs for Class 11th & 12th in Thane</h2>
            <div className="ElevenSeconMainDiv">
              <div className="elevenMultipleText">
                <div className="elevenMultipleInnerDiv">
                  <img src={dot} />
                  <h3>Subjects Covered:</h3>
                </div>
                <p>
                  • Physics <br></br>• Chemistry<br></br>• Mathematics (PCM) /
                  Biology (PCB)<br></br>• English & Other Board Subjects
                  <br></br>
                </p>
              </div>
              <div className="elevenMultipleText">
                <div className="elevenMultipleInnerDiv">
                  <img src={dot} />
                  <h3>Exam Preparation:</h3>
                </div>
                <p>
                  • Weekly tests, assignments, and 3 prelim exams<br></br>•
                  Regular doubt-solving sessions<br></br>• Board exam-focused
                  study material & mentorship<br></br>
                </p>
              </div>
            </div>
          </div>

          <div className="ElevenSeconDiv">
            <h2>Admission Process for Science Coaching in Thane</h2>
            <p>
              ✔️ Direct admission<br></br>
              ✔️ Career counseling to help students choose the right subjects
              <br></br>
              ✔️ Limited batch size for personalized attention<br></br>
              📞 Contact us today to secure your admission at our Thane coaching
              center<br></br>
            </p>
          </div>

          <div id="landtestimonialmain" className="cbsetestimonial">
            <h3>
              <b>Student & Parent Testimonials – Nayak’s Tutorials, Thane</b>
            </h3>
            <div className="mainTestDiv" id="firstTestimonial">
              <div className="testimonialfirst">
                <div style={{ padding: "10px" }} className="testImgDiv">
                  <img src={person} alt="testimonial one" />
                </div>
              </div>
              <div className="testimonialsecond">
                <h5 className="TName">Student</h5>
                <p>
                  {" "}
                  Nayak’s Tutorials transformed the way I understood Science.
                  The teachers made Physics and Chemistry easy with real-life
                  examples and problem-solving techniques. The weekly tests and
                  interactive doubt-clearing sessions helped me stay ahead in my
                  studies. Thanks to their structured approach, I scored
                  excellent marks in my board exams!
                </p>
              </div>
              <div className="testimonialthird">
                <img src={coma} />
              </div>
            </div>
            <div className="mainTestDiv" id="lastTestimonial">
              <div className="testimonialfirst">
                <div style={{ padding: "10px" }} className="testImgDiv">
                  <img src={person} alt="testimonial two" />
                </div>
              </div>
              <div className="testimonialsecond">
                <h5 className="TName">Student</h5>
                <p>
                  Before joining Nayak’s Tutorials, I struggled with
                  Mathematics, but their expert faculty helped me grasp
                  difficult concepts with ease. The personalized attention and
                  topic-wise tests boosted my confidence, and I was able to
                  secure top grades. Highly recommended for any Science student
                  in Thane!
                </p>
              </div>
              <div className="testimonialthird">
                <img src={coma} />
              </div>
            </div>
            <div className="mainTestDiv" id="lastTestimonial">
              <div className="testimonialfirst">
                <div style={{ padding: "10px" }} className="testImgDiv">
                  <img src={person} alt="testimonial three" />
                </div>
              </div>
              <div className="testimonialsecond">
                <h5 className="TName">Student</h5>
                <p>
                  Studying at Nayak’s Tutorials gave me a strong foundation in
                  Biology and Chemistry, which helped me with my NEET
                  preparation as well. The teachers ensure that every student
                  gets individual attention, and the small batch size makes
                  learning more effective. I highly recommend it to all Science
                  students!
                </p>
              </div>
              <div className="testimonialthird">
                <img src={coma} />
              </div>
            </div>
          </div>
        </div>
        <div className="elevenfourthTips">
          <div className="elevenfourthInner">
            <h3>Why Choose Nayak’s Tutorials for Science Coaching in Thane?</h3>
            <p className="redBoxxImghead">
              ✔️ Offline Classroom Coaching in Thane – Structured, interactive,
              and engaging sessions<br></br>
              ✔️ Experienced Faculty in Thane – Industry experts and subject
              specialists<br></br>
              ✔️ Dedicated Separate Batches for IIT-JEE & NEET – Focused
              preparation & targeted strategies<br></br>
              ✔️ Regular Weekly & Monthly Tests – Topic-wise assessments for
              better performance<br></br>
              ✔️ Small Batch Sizes in Thane – Ensuring personal attention &
              one-on-one mentorship<br></br>
              ✔️ Prelims & Final Exam Preparation – Helping students build exam
              confidence<br></br>
              📞 Enroll Today at Nayak’s Tutorials, Thane & Take the First Step
              Toward Success!<br></br>
            </p>
            <br></br>
          </div>
        </div>

        <div className="elevenLastDiv">
          <h3 className="elevenFaq">
            Frequently Asked Questions (FAQs) – Nayak’s Tutorials, Thane
          </h3>
          <Accordion allowMultipleExpanded={false} allowZeroExpanded>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  1 Have your offline/physical classes in Thane started?
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                Yes! Our offline classes in Thane are fully operational
                following all necessary precautions.
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <Accordion allowMultipleExpanded={false} allowZeroExpanded>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  2️ Do you offer online classes?
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                Currently, we focus on offline coaching in Thane to provide
                students with personalized attention and interactive learning.
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <Accordion allowMultipleExpanded={false} allowZeroExpanded>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  3️ Do you have separate batches for IIT-JEE & NEET?
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                Yes! We have dedicated IIT-JEE & NEET batches with customized
                study plans and targeted preparation strategies.
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <Accordion allowMultipleExpanded={false} allowZeroExpanded>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  4️ What is the batch size for Science, JEE & NEET coaching?
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                We maintain small batch sizes to ensure personalized learning
                and one-on-one mentorship.
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <Accordion allowMultipleExpanded={false} allowZeroExpanded>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  5️ Do you provide study material?
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                Yes! We provide comprehensive study material, weekly tests, and
                revision notes for all subjects.
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
        </div>
        <Footer />
        <a href="https://wa.me/+917710010044" target="_blank">
          <div className="wpicon">
            <FaWhatsapp id="faWp" size={50} color="white" />
          </div>
        </a>
      </div>
    </>
  );
}
